import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ConnectorsTableconstant } from "./ConnectorsTableConstant";

const initialState = {
  ConnectorsTableList: [],
  ConnectorsTable: {
    isLoading: true,
  },
  AddPowerList: [],
  powermap: {
    isLoading: true,
  },
};

export const ConnectorsTableReducer = persistReducer(
  {
    storage,
    key: "ConnectorsTable",
    whitelist: ["ConnectorsTableList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case ConnectorsTableconstant.CONNECTORS_TABLE_REQUEST: {
        return {
          ...state,
          ConnectorsTableList: [],
          ConnectorsTable: {
            isLoading: true,
          },
        };
      }

      case ConnectorsTableconstant.CONNECTORS_TABLE_RESPONSE: {
        return {
          ...state,
          ConnectorsTableList: payload,
          ConnectorsTable: {
            isLoading: false,
          },
        };
      }

      //******power post */

      case ConnectorsTableconstant.POST_POWER_MAP_REQUEST: {
        return {
          ...state,
          AddPowerList: [],
          powermap: {
            isLoading: true,
          },
        };
      }

      case ConnectorsTableconstant.POST_POWER_MAP_RESPONSE: {
        return {
          ...state,
          AddPowerList: payload,
          powermap: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
